export default __webpack_public_path__ + "static/media/nvts_logo.2490b7ae.png";